import type { TransactionAnalyticsRecord } from '../hooks/use-transaction-subscription.ts';
import type { TransactionAnalyticsItem } from './schema.ts';

/** cartItemGroup values that indicate a child sponsorship */
export const sponsorshipGroups = new Set([
  'ChildSelected',
  'LongestWaiting',
  'FirstPayment',
  'EPayment',
  'ChildCriteria',
]);

/** Returns true if the transaction should be processed (not blacklisted) */
export const isValidTransaction = (tx: TransactionAnalyticsRecord): boolean => {
  return !tx.isBlacklisted;
};

/** Extracts sponsorship items from a transaction's items array */
export const extractSponsorshipItems = (
  items: unknown[],
): TransactionAnalyticsItem[] => {
  if (!Array.isArray(items)) {
    return [];
  }
  return items.filter(
    (item): item is TransactionAnalyticsItem =>
      item != null &&
      typeof item === 'object' &&
      'cartItemGroup' in item &&
      typeof (item as Record<string, unknown>).cartItemGroup === 'string' &&
      sponsorshipGroups.has(
        (item as Record<string, unknown>).cartItemGroup as string,
      ),
  );
};

/** Returns true if an item has a valid beneficiaryName (non-null, non-empty after trim) */
export const hasValidBeneficiaryName = (
  item: TransactionAnalyticsItem,
): boolean => {
  return item.beneficiaryName != null && item.beneficiaryName.trim().length > 0;
};
